import { filter } from 'lodash';
import * as React from 'react';
import * as isEqual from 'react-fast-compare';
import * as ReactGA from 'react-ga';
import { connect } from 'react-redux';
import DataLoader from './common/loader/data-loader';
import Modal from './common/modal/modal';
import AppMenu from './menu/components/app-menu';
import PerformanceMessaging from './menu/components/performance-messaging';
import { IAppState } from './reducers/index';


interface IApplicationState {
    loadingText: string;
}

class App extends React.Component<IAppState, IApplicationState>{
    constructor(props: IAppState) {
        super(props);
        this.state = {
            loadingText: (window as any).loadingText
        }
        setTimeout(() => {
            let reactLoaderButton = document.getElementById("react-loader-button");

            if (reactLoaderButton !== undefined && props.appSettingsModel.stopLoadingAnimationButtonText !== "") {
                reactLoaderButton.setAttribute('style', "visibility: visible;");
            }
        }, 5000);
    }

    shouldComponentUpdate(nextProps: IAppState, nextState) {
        return !isEqual(this.props, nextProps);
    }

    /**
     * Only show the app menu if all the errors are set to false.
     */
    private get showAppMenu(): boolean {
        return filter(this.props.errorModel, (err: any) => err).every((err: any) => !err);
    }

    render() {
        return (
            <div>
                <a className="visually-hidden skip-link" href="#main-content">Skip to Main Content</a>
                {
                    (!this.props.appSettingsModel.itemId && !this.props.errorModel.getAppSettingsFailed) || this.props.applicationModel.loading ?
                        <DataLoader loadingSvgText={(window as any).loadingSvgText} loadingText={this.state.loadingText} />
                        :
                        <div className="main-content">
                            <AppMenu
                                {...this.props.appSettingsModel}
                                isSyosOnlyConfig={this.props.appSettingsModel.isSelectSeatVenue}
                                clientSymbolUrl={this.props.appSettingsModel.clientLeftNavLinkUrl}
                                rightNavUrl={this.props.appSettingsModel.clientRightNavLinkUrl}
                                headingTitle={this.props.appSettingsModel.itemName}
                                altText={this.props.appSettingsModel.altText}
                                cartConflictErrorHeading={this.props.appSettingsModel.cartConflictErrorHeading}
                                viewFromSeatModalActive={this.props.applicationModel.viewFromSeatModalActive}
                                dispatch={this.props.dispatch}
                                isExchange={this.props.appSettingsModel.exchangeTickets.length > 0}
                                isSeatmapView={this.props.location.pathname === "/seatmap" || this.props.appSettingsModel.isSelectSeatVenue ? true : false}
                                performanceDateString={this.props.location.pathname === "/seatmap" ? `${this.props.appSettingsModel.performanceDateString} | ${this.props.appSettingsModel.performanceTimeString}` : null}
                                seatmapFiltersIsOpen={this.props.seatMapModel.openSeatmapFilters}
                                seatmapCartIsOpen={this.props.seatMapModel.openSeatmapCart}
                                seatmapCartText={this.props.appSettingsModel.cartTitle}
                                cartSeatsCount={this.props.cartModel.seats.length}
                                cartTimerMessaging={this.props.appSettingsModel.cartTimerWithCountMessage}
                                cartUrl={this.props.appSettingsModel.cartUrl}
                                cartTimerExpiringMinute={this.props.appSettingsModel.cartTimerExpiringMinute}
                                remainingCartTimer={this.props.cartModel.remainingTessituraCartTimer}
                    />

                            {this.props.appSettingsModel.performanceMessaging != null && this.props.appSettingsModel.performanceMessaging.length > 0 ?
                                <PerformanceMessaging performanceMessaging={this.props.appSettingsModel.performanceMessaging} />
                                : null
                            }
                            {
                                this.props.appSettingsModel.pricingRulesMessaging.length > 0 ?
                                    <PerformanceMessaging performanceMessaging={this.props.appSettingsModel.pricingRulesMessaging} />
                                : null
                            }
                            {
                                this.props.cartModel.reservingSeats ?
                                    <div className="loading-container">
                                        <DataLoader loadingSvgText={(window as any).loadingSvgText} loadingText={this.props.appSettingsModel.reservingSeatMessage} />
                                    </div>
                                    : null
                            }
                            {this.props.cartModel.reserveResult != null ?
                                <Modal modalKey="reserve result" isError={true} title={this.props.appSettingsModel.cartTitle}
                                    message={this.props.cartModel.reserveResult.message}
                                    confirmFunction={this._reserveResultRedirect.bind(this)}
                                    closeFunction={this._reserveResultRedirect.bind(this)}
                                    confirmString={this.props.cartModel.reserveResult.redirectButtonText}
                                    priority={1}
                                />
                                : null
                            }
                            {this.props.children}
                        </div>
                }
            </div>
        );
    }

    _reserveResultRedirect() {
        window.location.replace(this.props.cartModel.reserveResult.redirectUrl);
    }

    componentDidMount() {
        ReactGA.initialize(this.props.appSettingsModel.googleAnalyticsId);
    }
}

//export default Filter;
export default connect((state) => state)(App);